import React from 'react';
import { EyeIcon, LayersIcon } from 'lucide-react';
import { highlightClosing, highlightItems, highlightTitle, solutionIntro, solutionTitle } from '../data/content';
export function Solution() {
  return <section id="solucion" className="w-full bg-night-900 py-16 md:py-24" data-id="element-165" data-mp="10s4pg8ok7qdm">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-166" data-mp="15rqz6856ioho">
        <div className="mx-auto max-w-narrow text-center" data-id="element-167" data-mp="15pxs4rqnm295">
          <p className="inline-flex items-center gap-2 rounded-full bg-night-700 px-5 py-2 font-display text-xs font-bold uppercase tracking-[0.2em] text-gold-300 ring-1 ring-gold-400/25" data-id="element-168" data-mp="qu8ephzjaxg1">
            <LayersIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-169" data-mp="hvd8w70ejpd9" />
            48 leyes ilustradas
          </p>

          <h2 className="mt-7 font-display text-[2rem] font-bold leading-[1.15] tracking-tight text-ink md:text-[2.75rem]" data-id="element-170" data-mp="mtoiqhqp5zvh">
            {solutionTitle}
          </h2>

          {solutionIntro.map(paragraph => <p key={paragraph} className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-171" data-mp="2h538gyjpjzb8">
              {paragraph}
            </p>)}
        </div>

        <div className="mx-auto mt-14 max-w-narrow rounded-2xl bg-night-700 p-7 shadow-soft ring-1 ring-white/5 md:p-10" data-id="element-172" data-mp="2ynf34kq7tvx">
          <h3 className="flex items-start gap-3 font-display text-xl font-bold leading-snug tracking-tight text-gold-300 md:text-2xl" data-id="element-173" data-mp="gso2x3a53whi">
            <EyeIcon className="mt-1 h-6 w-6 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-174" data-mp="3k6qtq2cohkdv" />
            {highlightTitle}
          </h3>

          <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-175" data-mp="3g79o98x94n8p">
            {highlightItems.map(item => <li key={item} className="rounded-xl bg-night-600 px-5 py-4 text-ink ring-1 ring-white/5" data-id="element-176" data-mp="3u7183qag8xum">
                {item}
              </li>)}
          </ul>

          <p className="mt-8 font-display text-xl font-bold leading-snug tracking-tight text-ink md:text-2xl" data-id="element-177" data-mp="19h24ft0ftaxt">
            {highlightClosing}
          </p>
        </div>
      </div>
    </section>;
}